import * as tablesPH from './ph/tables/index';
import * as tablesID from './id/tables/index';
import  * as remittanceFiltersPH  from './ph/filters/index';
import  * as remittanceFiltersID  from './id/filters/index';

const COUNTRY = process.env.REACT_APP_COUNTRY_CODE || 'ph';

const tableMap: Record<string, any> = {
  ph: tablesPH,
  id: tablesID,
};

const filterMap: Record<string, any> = {
  ph: remittanceFiltersPH,
  id: remittanceFiltersID,
};

export const tables = tableMap[COUNTRY] || tablesPH;
export const filters = filterMap[COUNTRY] || remittanceFiltersPH;